<script lang="ts" setup>

	import type {DeliveryDate} from 'dummen-shared';
	import {useI18n} from 'vue-i18n';
	import {ref} from 'vue';

	defineProps<{
		deliveryDates: DeliveryDate[];
	}>();

	const {t} = useI18n();

	const selectedDeliveryDate = ref<string>('');

	const getNormalizedWeekIncludingLabel = (deliveryDate: DeliveryDate) => {
		return t('shoppingcart.generic.week.text') + ' ' + deliveryDate.week;
	};

	const updateDeliveryDate = (event: Event) => {
		const element = event.target as HTMLInputElement;

		if (!element?.value) {
			return;
		}

		selectedDeliveryDate.value = element.value;

		const weekElement: HTMLElement | null = document.getElementById(element.value);
		weekElement?.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
	};

</script>

<template>
	<div class="shoppingcart-header__jump">
		<label for="jumptoselect">
			{{ t('shoppingcart.jumpTo.text') }}
		</label>

		<select id="jumptoselect"
		        :value="selectedDeliveryDate"
		        @change="updateDeliveryDate($event)">

			<option disabled selected value="">Select a week</option>

			<option v-for="deliveryDate in deliveryDates"
			        :key="`${deliveryDate.week}-${deliveryDate.year}`"
			        :value="`week-${deliveryDate.week}-${deliveryDate.year}`">

				{{ getNormalizedWeekIncludingLabel(deliveryDate) }}
			</option>
		</select>
	</div>
</template>

<style lang="scss" scoped>
	@use 'sass:math';

	#jumptoselect {
		display: block;
		border: #ebebeb 3px solid;
		font-weight: 500;
		color: #595959;
		line-height: 32px;
		-webkit-appearance: none;
		-moz-appearance: none;
		background: #ffffff url("/assets/images/build/icons/icon-caret-down.svg?inline") no-repeat;
		background-position-x: 100%;
		background-position-y: 5px;
		padding: 0 2rem 0 10px;
	}
</style>
